import { useRef, useInsertionEffect} from 'react'
import { useLocation } from 'react-router-dom'
import { Outlet, } from 'react-router-dom'
import Background from '#Components/Background'
import useLoading from '#Context/Loading'
import Boundary from '#Components/Boundary'
import Spinner from '#Components/Spinner'
import Navbar from '#Components/Navbar'

export default function SuperStructure() {
    // console.log('SuperStructure Render')
    const mainBox = useRef(null)
    const { status, error, mounted } = useLoading(); 
    const location = useLocation();

    //reset scroll to top on navigations
    useInsertionEffect(() => {
        if (mainBox.current) mainBox.current.scrollTo(0, 0)
    }, [location])

    return (
        <>
            <Navbar></Navbar>
            <Background></Background>
            <main ref={mainBox} id='mainBox' className="p-sm-5 p-lg-0" style={{ position: 'relative', top: '13dvh', width: '100vw', height: '87dvh', overflow: 'auto' }}>
                {/* {mounted ? old version*/}
                <Boundary fb={<Fallback></Fallback>} {...{ status, error }}>
                    <Outlet></Outlet>
                </Boundary>
            </main>
        </>
    )
}

function Fallback() {
    return (
        <div className="d-flex justify-content-center align-items-center" style={{ height: '87dvh', width: '100vw', position: 'fixed', top: '13dvh' }}>
            <Spinner options={{ lineWidth: 3, petals: 9, tailLength: 'short', radius: 50, persist: true, counterSpin: true, }}></Spinner>
        </div>
    )
}



